/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useMainContext from "utils/context/useMainContext";

const useFatalError = () => {
    const mainContext = useMainContext();
    const [fatalError, setFatalError] = useState(false);
	useEffect(() => {
        if (!fatalError) return;
        mainContext.setShowDialogUnexpectedError(true);
    }, [fatalError]);
	useEffect(() => {
        mainContext.reloadForUnexpectedError(fatalError);
    }, [mainContext.showDialogUnexpectedError]);
	function notifyFatalError() {
		setFatalError(true);
	}
	return {
		value: fatalError,
		notify: notifyFatalError
	};
}	
	
export default useFatalError;